import React, { useState } from "react";
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

type FAQItem = {
  question: string;
  answer: string;
};

type Props = {
  colored?: boolean;
};

export default function FAQSection({ colored }: Props) {
  const [expanded, setExpanded] = useState<{ [key: string]: boolean }>({});

  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded((prev) => ({
      ...prev,
      [panel]: isExpanded,
    }));
  };

  const faqData: FAQItem[] = [
    {
      question: "査定は無料ですか？",
      answer: "無料です。",
    },
    {
      question: "居住用、投資用どちらを対応してますか？",
      answer: "どちらも対応しております。",
    },
    {
      question: "色々な業者から電話がかかってきませんか？",
      answer:
        "Propallyは一括査定では無いので、そのようなことはありません。必要であればエリアで一番信頼の会社にお繋ぎします。",
    },
  ];

  return (
    <Box>
      {faqData.map((faq, index) => (
        <Accordion
          key={index}
          expanded={expanded[`panel${index}`] || false}
          onChange={handleChange(`panel${index}`)}
          sx={{
            backgroundColor: "#F5F5F5",
            boxShadow: "none",
            "&:before": {
              display: "none",
            },
            "&.Mui-expanded": {
              minHeight: "0",
              margin: "8px 0",
            },
            marginBottom: "8px",
          }}
        >
          <AccordionSummary
            expandIcon={
              expanded[`panel${index}`] ? (
                <RemoveIcon sx={{ color: "primary.dark" }} />
              ) : (
                <AddIcon sx={{ color: "primary.dark" }} />
              )
            }
            sx={{
              backgroundColor: "#F5F5F5",
              borderRadius: "4px",
              boxShadow: "4px 4px 10px rgba(56, 61, 81, 0.25)",
              padding: "12px 10px",
              "& .MuiAccordionSummary-content": {
                margin: "0",
                "&.Mui-expanded": {
                  margin: "0",
                },
              },
            }}
          >
            <Typography>{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              backgroundColor: colored ? "primary.light" : "white",
              padding: "12px 10px",
            }}
          >
            <Typography>{faq.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}
